import constants from "../../core/constants";

class Controller {
  constructor($injector, $mdDialog, $scope, $rootScope, $transitions) {
    "ngInject";
    this.$transitions = $transitions;
    this.Events = $injector.get("Events");
    this.BoardingCheckin = $injector.get("BoardingCheckin");
    this.Messages = $injector.get("Messages");
    this.$mdDialog = $mdDialog;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.showSuccessNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.warningMessages = {
      Category:
        "This will change the configuration for all schedules in this category ? Are you sure?",
      Corporate:
        "This will change the configuration for all schedules for this corporate ? Are you sure?",
    };
    this.toggles = [
      {
        label: "List",
        name: "list",
        value: true,
      },
      {
        label: "Qr code",
        name: "qrCode",
        value: false,
      },
    ];
    this.state = {
      changed: false,
      initial: { list: true, qrCode: false },
      saveLoading: false,
      dataLoaded: false,
    };
  }

  $onInit() {
    this.$scope.$watch(
      "$ctrl.levelId",
      () => {
        this.getConfiguration();
      },
      false
    );
    this.getConfiguration = () => {
      this.BoardingCheckin.getConfig(this.level, this.levelId).$promise.then(
        (response) => {
          if (response) {
            const [listCheckin, qrCode] = this.toggles;
            listCheckin.value = response.is_list_allowed;
            qrCode.value = response.is_qr_code_allowed;
            this.state.initial.list = response.is_list_allowed;
            this.state.initial.qrCode = response.is_qr_code_allowed;
            this.state.dataLoaded = true;
          }
        },
        (errResponse) => {
          this.state.dataLoaded = true;
          this.showError(errResponse);
        }
      );
    };
    this.save = () => {
      if (
        [
          constants.boardingCheckinLevels.category,
          constants.boardingCheckinLevels.corporate,
        ].includes(this.level)
      ) {
        const confirm = this.$mdDialog
          .confirm()
          .title(`Warning`)
          .textContent(this.warningMessages[this.level])
          .ok("Ok")
          .cancel("Cancel");
        this.$mdDialog.show(confirm).then(() => {
          this.updateConfig();
        });
      } else {
        this.updateConfig();
      }
    };

    this.onToggleChange = (toggleName, toggleValue) => {
      // One method must be checked always
      if (!toggleValue) {
        this.toggles.find((toggle) => toggle.name !== toggleName).value = true;
      }
      // Check if any toggle value changed to enable/disable save button
      const initialChanged = ["qrCode", "list"].some(
        (_name) =>
          this.toggles.find(({ name }) => name === _name).value !==
          this.state.initial[_name]
      );
      if (initialChanged) this.state.changed = true;
      else this.state.changed = false;
    };
    this.watchNavigationChanges();
  }

  watchNavigationChanges() {
    window.onbeforeunload = this.handleUnloadEvent.bind(this);
    this.onStartDeregister = this.$transitions.onStart({}, (transition) => {
      if (this.state.changed) {
        if (
          // eslint-disable-next-line no-alert
          !window.confirm(
            "your checkin method changes won't be saved , are you sure ?"
          )
        ) {
          transition.abort();
        }
      }
    });
  }

  updateConfig() {
    const [listCheckin, qrCode] = this.toggles;
    const payload = {
      level: this.level,
      level_key: this.levelId,
      is_qr_code_allowed: qrCode.value,
      is_list_checkin_allowed: listCheckin.value,
    };
    this.state.saveLoading = true;
    this.BoardingCheckin.saveConfig(payload).$promise.then(
      () => {
        this.state.changed = false;
        this.state.initial = { qrCode: qrCode.value, list: listCheckin.value };
        this.Events.emit(
          this.showSuccessNotificationEvent,
          this.Messages.updateMessage(
            this.level.toLowerCase(),
            "Checkin method"
          )
        );
        this.state.saveLoading = false;
      },
      (errResponse) => {
        this.state.saveLoading = false;
        this.showError(errResponse);
      }
    );
  }
  showError(response) {
    const responseData = response.data;
    this.Events.emit(this.errorEvent, responseData);
  }
  handleUnloadEvent() {
    if (this.state.changed) return "unsaved changes";
    return undefined;
  }

  $onDestroy() {
    window.onbeforeunload = null;
    this.onStartDeregister();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/checkInConfiguration/checkInConfiguration.controller.js